module.exports = __webpack_public_path__ + "static/media/littlemac_0.5b731ec9.png";